/** Public GitHub username for contribution calendar (must match profile URL). */
export const GITHUB_USERNAME = "khanmo97";

/** Matches GitHub.com dark-mode contribution graph (green ramp). */
export const GITHUB_CONTRIBUTION_GRAPH_THEME = {
  background: "transparent",
  text: "#ffffff",
  grade0: "#161b22",
  grade1: "#0e4429",
  grade2: "#006d32",
  grade3: "#26a641",
  grade4: "#39d353",
};
